import { render, staticRenderFns } from "./footer-subscribe.vue?vue&type=template&id=f6aab288&scoped=true&"
import script from "./footer-subscribe.vue?vue&type=script&lang=js&"
export * from "./footer-subscribe.vue?vue&type=script&lang=js&"
import style0 from "./footer-subscribe.vue?vue&type=style&index=0&id=f6aab288&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6aab288",
  null
  
)

export default component.exports